import { setToken, clearToken, getToken } from '@dts/shared/src/utils/system';
import store from '@dts/shared/src/store';
import { dashboardApi } from '@/api/modules/dashboard';
import { loginApi } from '@/api/modules/login';

import 'nprogress/nprogress.css';
import NProgress from 'nprogress';

import router from '.';

NProgress.configure({ showSpinner: false });
const whiteList = ['sso', 'login'];
const directSsoRoutes = ['edmWebpage'];

const redirectToSso = (redirect: string) => {
  loginApi
    .getSSOUrl({ state: encodeURIComponent(encodeURIComponent(redirect)) })
    .then((href) => {
      window.location.href = href;
    })
    .catch(() => {
      router.push({
        name: 'login',
        query: {
          redirect,
        },
      });
    });
};

router.beforeEach((to, _from, nextTo) => {
  store.dispatch('user/setTab', to.path.split('/')[1]);
  NProgress.start();
  const urlToken = getToken();

  if (urlToken !== '' && urlToken !== null) {
    setToken(urlToken);
    store.dispatch('user/loginByToken', urlToken);
  }

  if ((store.state as any).user.token || urlToken) {
    nextTo();
    return;
  }

  if (whiteList.indexOf(String(to.name)) !== -1) {
    NProgress.done();
    nextTo();
    return;
  }

  if (!urlToken) {
    if (directSsoRoutes.includes(String(to.name))) {
      nextTo(false);
      NProgress.done();
      redirectToSso(to.fullPath);
      return;
    }

    nextTo({
      name: 'login',
      query: {
        redirect: to.fullPath,
      },
    });
    return;
  }
  nextTo();
});

router.afterEach((to, from) => {
  const token = getToken() ?? (store.state as any).user.token;
  if (!token) {
    NProgress.done();
    return;
  }

  const { name, meta: toMeta } = to;
  const { meta: fromMeta } = from;

  if (toMeta.pid) {
    const sourceId = fromMeta?.pid ?? to.query?.pid ?? undefined;
    console.log(sourceId);
    if (sourceId === toMeta.pid) {
      NProgress.done();
      return;
    }

    dashboardApi.recordPageView({
      pageId: toMeta.pid as number,
      sourceId: sourceId as number,
    });
  }

  switch (name) {
    case 'login':
      return loginApi
        .validateLoginToken()
        .then(() => {
          router.push({
            path: '/home',
            query: {},
          });
          NProgress.done();
        })
        .catch(() => {
          clearToken();
          store.dispatch('user/removeStoreToken');
          NProgress.done();
        });
    case 'sso':
      return;
    default:
      return loginApi
        .validateLoginToken()
        .then(() => {
          NProgress.done();
        })
        .catch(() => {
          clearToken();
          store.dispatch('user/removeStoreToken');
          if (directSsoRoutes.includes(String(to.name))) {
            redirectToSso(to.fullPath);
            NProgress.done();
            return;
          }

          router.push({
            path: '/login',
            query: {
              redirect: to.fullPath,
            },
          });
          NProgress.done();
        });
  }
});
